import loadable from '@loadable/component';

export const UserDashboardViewEventPageLoadable = loadable(
  () => import('./UserDashboardViewEventPage'),
  {
    resolveComponent: (module) => module.UserDashboardViewEventPage,
  },
);
